import React from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import MapLocation from './MapLocation';
import Header from './Header';
import HeaderNew from './HeaderNew';

const Root = styled.div``;

function ContactUs() {
    return (
        <Root>
            <Helmet>
              <title>Contact BastionEx | Get in Touch with Blockchain & IT Experts</title>
              <meta name="description" content="Contact BastionEx for blockchain, AI, web, mobile app, and software development solutions. Connect with our experts and discuss your project requirements today." />
              <link rel="canonical" href="https://bastionex.net/contact_us" />
            </Helmet>
            {/* <Header /> */}
            <HeaderNew />
            <MapLocation />
        </Root>
    );
}

export default ContactUs;